import { useQuery } from 'react-query';

import { getAddDataMultiTraps } from 'api/traps/Trap/getAddMultiTrapsData';

export const useGetAddMultiTrapsData = (slug: string) => {
  const { data, refetch, isLoading } = useQuery('MultiCathTraps', () => getAddDataMultiTraps(slug), {
    enabled: !!slug,
    refetchOnWindowFocus: false,
  });

  return { trapOptions: data, refetch, isLoading };
};

export default useGetAddMultiTrapsData;
